export enum FeedVersionActionTypes {
    SET_FEEDVERSIONS = "SET_FEEDVERSIONS",
    CLEAR_FEEDVERSIONS = "CLEAR_FEEDVERSIONS"
}